<div
  *ngIf="!bubbleDesign && options.length > 0"
  class="toggle-container"
  [ngClass]="{ 'edit-mode': isEditMode }"
  [class.border-bottom]="showBorderBottom"
  [class.border]="showBorder"
  [ngStyle]="{
    'border-bottom': options.length === 1 ? 'solid 1px #0f84c0' : 'null',
    'justify-content': options.length === 1 ? 'center' : null,
  }"
>
  <div
    [ngStyle]="{ 'width.%': equalColumnsWidth ? 100 / options.length : 'auto' }"
    (click)="optionClickHandler(option)"
    [ngClass]="{ current: actifOption === option && options.length !== 1 }"
    *ngFor="let option of options"
    class="tab"
  >
    <p class="content">{{ option }}</p>
  </div>
</div>

<div
  fxLayout="row"
  fxLayoutAlign="start center"
  *ngIf="bubbleDesign && options.length > 0"
  style="gap: 8px"
  class="toggle-container-bubble"
>
  <div
    *ngFor="let option of options"
    [ngClass]="{ option: option !== actifOption, 'option-check': option === actifOption }"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <button class="option-button" mat-flat-button (click)="optionClickHandler(option)">
      {{ option }}
    </button>
    <mat-icon *ngIf="option === actifOption" class="option-icon">check</mat-icon>
  </div>
</div>
